/** Деэкранирует html-тэги и амперсанд */
export const unescapeHtml = (string: string) => {
  return string.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#39;/g, "'");
};
